import { Loader2 } from "lucide-react";

import { cn } from "../../lib/cn.js";

/**
 * A tasteful inline loading spinner (canon 01-ui/feedback-states.md).
 *
 * Prefer a `<Skeleton>` for initial page/list loads — the user perceives the
 * layout taking shape. Reach for this spinner only where a skeleton does not
 * fit: full-screen auth gates, small inline controls, and short in-panel waits.
 *
 * `role="status"` + a label (visible or sr-only) keeps it announced to screen
 * readers.
 */
export function Spinner({
  className,
  label = "Loading…",
  showLabel = true,
}: {
  className?: string;
  /** Announced label; also shown as text unless `showLabel` is false. */
  label?: string;
  showLabel?: boolean;
}) {
  return (
    <span role="status" className="inline-flex items-center gap-2 text-sm text-fg-subtle">
      <Loader2 className={cn("h-4 w-4 animate-spin", className)} aria-hidden="true" />
      {showLabel ? <span>{label}</span> : <span className="sr-only">{label}</span>}
    </span>
  );
}
